import { api } from "./api";

// Servicios del módulo Conexión (Pilar 01)
export const ConexionAPI = {
  // Catálogos
  async catalogos() {
    const { data } = await api.get("/conexion/catalogos");
    return data;
  },
  async estadisticas() {
    const { data } = await api.get("/conexion/estadisticas");
    return data;
  },

  // Perfil extendido (con teléfono/ubicación/rol)
  async obtenerPerfil() {
    const { data } = await api.get("/conexion/perfil");
    return data;
  },
  async actualizarPerfil(payload) {
    const { data } = await api.put("/conexion/perfil", payload);
    return data;
  },
  // Publicaciones
  async listarPublicaciones(filtros = {}) {
    const { data } = await api.get("/conexion/publicaciones", { params: filtros });
    return data;
  },
  async misPublicaciones() {
    const { data } = await api.get("/conexion/publicaciones/mis");
    return data;
  },
  async detallePublicacion(id) {
    const { data } = await api.get(`/conexion/publicaciones/${id}`);
    return data;
  },
  async crearPublicacion(payload) {
    const { data } = await api.post("/conexion/publicaciones", payload);
    return data;
  },
  async eliminarPublicacion(id) {
    const { data } = await api.delete(`/conexion/publicaciones/${id}`);
    return data;
  },

  // Búsqueda
  async buscar(filtros = {}) {
    const { data } = await api.get("/conexion/buscar", { params: filtros });
    return data;
  },

  // Chat
  async listarConversaciones() {
    const { data } = await api.get("/conexion/conversaciones");
    return data;
  },
  async abrirConversacion(destinatarioId) {
    const { data } = await api.post(`/conexion/conversaciones/${destinatarioId}`);
    return data;
  },
  async obtenerMensajes(convId) {
    const { data } = await api.get(`/conexion/conversaciones/${convId}/mensajes`);
    return data;
  },
  async enviarMensaje(convId, texto) {
    const { data } = await api.post(`/conexion/conversaciones/${convId}/mensajes`, { texto });
    return data;
  },
  async enviarAdjunto(convId, file, duracion) {
    const form = new FormData();
    form.append("file", file);
    if (duracion != null) form.append("duracion", String(duracion));
    const { data } = await api.post(`/conexion/conversaciones/${convId}/adjuntos`, form, {
      headers: { "Content-Type": "multipart/form-data" },
    });
    return data;
  },
  async pingPresencia() {
    try {
      await api.post("/conexion/presencia/ping");
    } catch (_) {
      /* silencioso */
    }
  },
  async mensajesNoLeidos() {
    try {
      const { data } = await api.get("/conexion/no-leidos");
      return data.total || 0;
    } catch (_) {
      return 0;
    }
  },
};

export const TIPO_META = {
  solicitud: { label: "CLIENTE",              color: "#DC2626", tint: "rgba(220,38,38,0.10)", icon: "search" },
  oferta:    { label: "MAESTRO-CONTRATISTA",  color: "#16A34A", tint: "rgba(22,163,74,0.10)", icon: "megaphone" },
  producto:  { label: "FERRETERÍA",           color: "#D97706", tint: "rgba(217,119,6,0.10)", icon: "box" },
};

export const ROL_META = {
  cliente:      { label: "Cliente",           color: "#1E3A8A" },
  contratista:  { label: "Maestro-Contratista", color: "#7E22CE" },
  maestro:      { label: "Maestro-Contratista", color: "#7E22CE" },
  profesional:  { label: "Maestro-Contratista", color: "#7E22CE" },
  ferreteria:   { label: "Ferretería",        color: "#D97706" },
};

// Devuelve el título del dashboard según el rol
export function tituloDashboardPorRol(rol) {
  switch (rol) {
    case "cliente":     return "¿Qué necesitas construir hoy?";
    case "contratista": return "Nuevas oportunidades para ti";
    case "ferreteria":  return "Publicaciones de clientes";
    default:            return "Bienvenido al Ecosistema";
  }
}

// Filtro por defecto según rol (feed personalizado)
export function filtroInicioPorRol(rol) {
  if (rol === "contratista" || rol === "ferreteria") return { tipo: "solicitud" };
  return {};
}

// Formatea "hace X" a partir de ISO string
export function haceCuanto(iso) {
  if (!iso) return "";
  const diff = Date.now() - new Date(iso).getTime();
  const sec = Math.max(0, Math.floor(diff / 1000));
  if (sec < 60) return "Hace segundos";
  const min = Math.floor(sec / 60);
  if (min < 60) return `Hace ${min} min`;
  const h = Math.floor(min / 60);
  if (h < 24) return `Hace ${h} h`;
  const d = Math.floor(h / 24);
  if (d < 30) return `Hace ${d} d`;
  return new Date(iso).toLocaleDateString("es-PE");
}

export function formatearPrecio(v) {
  if (v == null || v === undefined) return null;
  return `S/ ${Number(v).toFixed(2)}`;
}
